module.exports = "/assets/images/calendar_cc310d.svg";